import { memo } from 'react'

declare global {
  interface Window {
    gtag: any
  }
}

export const GoogleAnalytics = memo(function GoogleAnalytics() {
  return null
})
